import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getFormValues, getFormSyncErrors } from 'redux-form';

import { getState } from '../../../../store/store';

import ModalHeader from '../../../units/Modal/Header';

import { Wrapper } from './FormWrapperUnits';
import FormsComponents from '../formsComponentsConfig';

import CommandsActions from '../../../../store/forms/commands/commandsActions';
import FormActions from '../../../../store/forms/utils/formActions';
import FormsActions from '../../../../store/forms/formsActions';

import HttpService from '../../../../services/httpService';

import FormUtils from '../../../../utils/formUtils';
import NormalizeUtils from '../../../../utils/normalizeUtils';

class FormWrapper extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    instanceName: PropTypes.string.isRequired,
    instanceToken: PropTypes.string.isRequired,
    formId: PropTypes.string,
    config: PropTypes.object,
    actions: PropTypes.object,
    fields: PropTypes.object,
    params: PropTypes.object,
    errors: PropTypes.array,
    signInstanceName: PropTypes.string
  };

  static defaultProps = {
    formId: null,
    actions: {},
    fields: {},
    params: {},
    config: {},
    errors: [],
    signInstanceName: null
  };

  getFormErrors = () => {
    return getFormSyncErrors(this.props.formId)(getState());
  };

  getFormValues = () => {
    return getFormValues(this.props.formId)(getState());
  };

  isFormValid = () => {
    const formErrors = this.getFormErrors();

    return formErrors ? Object.keys(formErrors).length > 0 : false;
  };

  getActionProps = ({ actionId }) => {
    const action = this.props.actions[actionId];

    if (!action) {
      return {
        visible: false
      };
    }

    return {
      ...action,
      name: actionId,
      visible: action.visible
    };
  };

  getFieldProps = (fieldId, fieldParams = {}) => {
    const field = this.props.fields[fieldId];

    if (!field) return null;

    const { config, formId } = this.props;

    const fieldConfig = config.fields[fieldId];

    if (!fieldConfig) return null;

    const props = {
      visible: field.visible,
      disabled: field.disabled,
      readOnly: field.strict,
      waitsServerResponse: field.waitsServerResponse,
      name: fieldId,
      maxLength: field.maxLength,
      fieldType: fieldConfig.fieldType
    };

    const isEditOnServer = field.onChange;
    const isFieldSelect = !field.disabled && fieldConfig.type === 'select';
    const isText = !field.disabled && fieldConfig.type === 'text';
    const isFieldBool = !field.disabled && fieldConfig.type === 'bool';

    if (isText) {
      if (isEditOnServer) {
        const changeField = (event, value) => {
          if (fieldParams && fieldParams.onChange) {
            fieldParams.onChange(value);
          }

          FormsActions.updateForm({
            instanceToken: this.props.instanceToken,
            fields: {
              [fieldId]: {
                waitsServerResponse: true
              }
            }
          });

          this.onChangeField(
            fieldId,
            FormUtils.getApiValue(
              {
                ...field,
                value
              },
              fieldConfig
            ),
            fieldConfig
          );
        };

        props.onChange = (event, value) => {
          FormsActions.addTimer({
            instanceToken: this.props.instanceToken,
            timerId: fieldId,
            timer: () => {
              changeField(event, value);
            },
            delay: 400
          });
        };

        props.onBlur = (event, value) => {
          if (
            FormsActions.isTimerExist({
              instanceToken: this.props.instanceToken,
              timerId: fieldId
            })
          ) {
            FormsActions.clearTimer({
              instanceToken: this.props.instanceToken,
              timerId: fieldId
            });
            changeField(event, value);
          }
        };
      } else {
        props.onChange = value => {
          FormActions.change(formId, {
            [fieldId]: value.target ? value.target.value : value
          });
        };
      }
    }

    if (isFieldSelect) {
      props.onChange = value => {
        FormActions.change(formId, {
          [fieldId]: value
        });
        if (fieldParams && fieldParams.onChange) {
          setTimeout(() => fieldParams.onChange(value), 0);
        }
        this.onChangeField(
          fieldId,
          FormUtils.getApiValue(
            {
              ...field,
              value
            },
            fieldConfig
          )
        );
      };
    }

    if (isFieldBool) {
      props.onChange = (e, value) => {
        if (typeof value === 'boolean') {
          this.onChangeField(
            fieldId,
            FormUtils.getApiValue(
              {
                ...field,
                value
              },
              fieldConfig
            ),
            fieldConfig
          );
        }
      };
    }

    if (field.errors && field.errors.length) {
      props.error = field.errors[0].message;
    }

    return {
      ...props,
      ...NormalizeUtils.getFieldProps(config.fields[fieldId])
    };
  };

  initRef = (fieldId, fieldConfig) => {
    FormsActions.initRef({
      instanceToken: this.props.instanceToken,
      instanceName: this.props.instanceName,
      fieldId,
      fieldConfig
    });
  };

  initRefViaAction = actionId => {
    if (!actionId) return;
    FormsActions.apply({
      instanceName: this.props.instanceName,
      instanceToken: this.props.instanceToken,
      actionId
    });
  };

  getRef = fieldId => {
    CommandsActions.apply({
      instanceToken: this.props.instanceToken,
      request: () => {
        return HttpService.put(`${this.props.instanceName}/refList`, {
          instanceToken: this.props.instanceToken,
          submitField: fieldId
        });
      }
    });
  };

  getRefItems = async fieldId => {
    const response = await HttpService.put(
      `${this.props.instanceName}/refList`,
      {
        instanceToken: this.props.instanceToken,
        submitField: fieldId
      }
    );
    if (
      !response ||
      !response.commands ||
      !response.commands.length ||
      !response.commands[1] ||
      !response.commands[1].list
    )
      return [];
    return response.commands[1].list;
  };

  onChangeField = async (fieldId, fieldValue) => {
    await FormsActions.onChangeField({
      instanceToken: this.props.instanceToken,
      fieldId,
      fieldValue
    });

    FormsActions.updateForm({
      instanceToken: this.props.instanceToken,
      fields: {
        [fieldId]: {
          waitsServerResponse: false
        }
      }
    });
  };

  applyAction = ({
    actionId,
    extActionId,
    values,
    requestParams,
    loaderParams
  }) => {
    const params = {
      instanceName: this.props.instanceName,
      instanceToken: this.props.instanceToken,
      actionId,
      extActionId
    };

    const requestValues = values
      ? {
          fields: FormUtils.getApiValues(
            this.props.fields,
            values,
            this.props.config.fields,
            this.getFormErrors()
          )
        }
      : null;
    const actionRequestParams = {
      ...requestValues,
      ...requestParams
    };

    return FormsActions.apply({
      ...params,
      requestParams: actionRequestParams,
      loaderParams
    });
  };

  applyRefAction = ({ instanceName, instanceToken, actionId, itemId }) => {
    FormsActions.actionRef({
      instanceName,
      instanceToken,
      actionId,
      itemId
    });
  };

  close = () => {
    FormsActions.clearTimers({ instanceToken: this.props.instanceToken });

    const formValues = this.getFormValues();

    this.applyAction({
      instanceName: this.props.instanceName,
      instanceToken: this.props.instanceToken,
      actionId: '_close',
      values: formValues
    });
  };

  renderHeader = ({ title, margin, size, close }) => {
    const width =
      typeof this.props.config.modalWidth === 'function'
        ? this.props.config.modalWidth({ ...this.props })
        : this.props.config.modalWidth;

    return (
      <ModalHeader
        title={title}
        margin={margin}
        size={size || (width === '100%' ? 'normal' : 'small')}
        onClose={typeof close === 'undefined' ? this.close : close}
      />
    );
  };

  getFormProps = () => {
    const formProps = {
      ...this.props,
      form: this.props.formId,
      formId: this.props.formId,
      config: this.props.config,
      getActionProps: this.getActionProps,
      applyAction: this.applyAction,
      applyRefAction: this.applyRefAction,
      getFieldProps: this.getFieldProps,
      getRef: this.getRef,
      getRefItems: this.getRefItems
    };

    const formModalProps =
      this.props.config.type === 'modal'
        ? {
            renderHeader: this.renderHeader,
            close: this.close
          }
        : {};

    return {
      ...formProps,
      ...formModalProps
    };
  };

  render() {
    const Form = FormsComponents.getByName(this.props.id);

    return (
      <Wrapper column justify="space-between">
        <Form {...this.getFormProps()} />
      </Wrapper>
    );
  }
}
export default FormWrapper;



// WEBPACK FOOTER //
// ./src/components/containers/Forms/FormWrapper/FormWrapper.js